module.exports = __webpack_public_path__ + "img/viata-si-petrecerea-sfintilor-1682-luna-februarie-big.9fdc4490.jpg";